import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
  width?: string;
}

const SearchNoResultIcon: React.FC<CustomIconProps> = ({ width }) => (
  <svg
    width={width ?? '145'}
    height={width ?? '145'}
    viewBox='0 0 145 145'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M57.9243 114.14C88.2583 114.14 112.849 89.2576 112.849 58.564C112.849 27.8705 88.2583 2.98828 57.9243 2.98828C27.5902 2.98828 2.99945 27.8705 2.99945 58.564C2.99945 89.2576 27.5902 114.14 57.9243 114.14Z'
      fill='#151515'
      stroke='#3C3B3E'
      strokeWidth='5'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M49.1229 101.688C52.0069 102.226 54.94 102.506 57.924 102.527C81.9196 102.527 101.372 82.8444 101.372 58.5645C101.372 34.2845 81.9196 14.6016 57.924 14.6016C51.7601 14.6016 45.8955 15.9005 40.5841 18.2422C31.3535 22.3125 23.7911 29.5324 19.2241 38.5605C16.1885 44.561 14.476 51.3604 14.476 58.5645C14.476 65.1008 15.886 71.3037 18.4142 76.8796C20.2193 80.8603 22.595 84.5217 25.4356 87.755'
      fill='black'
    />
    <path
      d='M49.1229 101.688C52.0069 102.226 54.94 102.506 57.924 102.527C81.9196 102.527 101.372 82.8444 101.372 58.5645C101.372 34.2845 81.9196 14.6016 57.924 14.6016C51.7601 14.6016 45.8955 15.9005 40.5841 18.2422C31.3535 22.3125 23.7911 29.5324 19.2241 38.5605C16.1885 44.561 14.476 51.3604 14.476 58.5645C14.476 65.1008 15.886 71.3037 18.4142 76.8796C20.2193 80.8603 22.595 84.5217 25.4356 87.755'
      stroke='#3C3B3E'
      strokeWidth='5'
      strokeLinecap='round'
    />
    <path
      d='M30.5395 92.6953C34.0612 95.5919 38.0404 97.9418 42.35 99.6166'
      stroke='#3C3B3E'
      strokeWidth='5'
      strokeLinecap='round'
    />
    <path
      d='M103.012 102.527L112.849 112.481'
      stroke='#3C3B3E'
      strokeWidth='4'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M111.26 110.871C108.156 114.011 108.156 119.101 111.26 122.242L129.434 140.631C132.538 143.772 137.569 143.772 140.672 140.631C143.775 137.492 143.775 132.401 140.672 129.261L122.497 110.871C119.394 107.731 114.363 107.731 111.26 110.871Z'
      fill='#121212'
      stroke='#3C3B3E'
      strokeWidth='4'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M47.2668 39.4874C47.2668 58.7283 62.6819 74.326 81.6973 74.326C85.433 74.326 89.0294 73.7238 92.397 72.6106C86.8996 86.4149 73.5365 96.159 57.9239 96.159C37.405 96.159 20.7709 79.3278 20.7709 58.5657C20.7709 39.7521 34.4284 24.1668 52.2593 21.4062C49.0917 26.6793 47.2668 32.8673 47.2668 39.4874Z'
      fill='#121212'
    />
  </svg>
);

export default SearchNoResultIcon;
